<template>
    <div id="register-step">
        <div class="alert alert-success font-weight-bold p-3 p-md-4 my-5">
            <div class="row align-items-center mx-n2 mx-md-n3">
                <div class="col-auto px-2 px-md-3">
                    <Icon name="success" width="2em" height="2em" />
                </div>
                <div class="col px-2 px-md-3">
                    <template v-if="message">
                        {{ message }}
                    </template>
                    <template v-else>
                        Votre inscription a bien été pris en compte
                    </template>
                </div>
            </div>
        </div>

        <div class="text-center mt-5">
            <a class="btn btn-primary" :href="accountUrl">
                Afficher dans mon compte &gt;
            </a>
        </div>
    </div>

</template>

<script>
    import Icon from "../../ui/Icon";
    import { baseUrl } from "../../../util/config";

    export default {
        components: {
            Icon
        },
        computed: {
            message() {
                return this.$route.query.message;
            },
            accountUrl() {
                return this.$route.query.account_url ?? this.baseUrl('/compte');
            },
        },
        methods: {
            baseUrl,
        }
    }
</script>
